/* global axios */
import ApiClient from './ApiClient';

class TalkviaOpenAIPromptsAPI extends ApiClient {
  constructor() {
    super('talkvia_openai_prompts', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { talkvia_openai_prompt: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_openai_prompt: data });
  }

  uploadKnowledgeBaseFile(promptId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${this.url}/${promptId}/talkvia_knowledge_base_files`,
      formData
    );
  }

  replaceKnowledgeBaseFile(promptId, fileId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.patch(
      `${this.url}/${promptId}/talkvia_knowledge_base_files/${fileId}`,
      formData
    );
  }

  deleteKnowledgeBaseFile(promptId, fileId) {
    return axios.delete(
      `${this.url}/${promptId}/talkvia_knowledge_base_files/${fileId}`
    );
  }
}

export default new TalkviaOpenAIPromptsAPI();
